import React, { createContext, useState, useContext, useEffect } from "react";
import { CustomerContext } from "../customer/CustomerContext";

// Tekliflerle ilgili verileri ve işlemleri paylaşmak için context oluşturuluyor
export const OfferContext = createContext();

export const OfferProvider = ({ children }) => {
  const { customers } = useContext(CustomerContext);

  // Teklifler state'i
  const [offers, setOffers] = useState([
    {
      id: 1,
      customerId: 1,
      offerDate: "2025-09-10",
      plannedDate: "2025-09-20",
      paymentMethod: "Nakit",
      status: "Beklemede",
      vatRate: 20,
      items: [
        { id: 1, name: "HP Pavilion 15", quantity: 1, price: 1500 },
        { id: 2, name: "Genel Bakım Ücreti", quantity: 1, price: 500 },
      ],
    },
    {
      id: 2,
      customerId: 2,
      offerDate: "2025-09-11",
      plannedDate: "2025-09-18",
      paymentMethod: "Kredi Kartı",
      status: "Onaylandı",
      vatRate: 20,
      items: [{ id: 1, name: "Samsung S21", quantity: 1, price: 2500 }],
    },
  ]);

  // Müşteri isimleri, toplam tutar ve ürün adları ile geliştirilmiş teklifler
  const [enhancedOffers, setEnhancedOffers] = useState([]);

  // Teklifler veya müşteriler değiştiğinde ek bilgileri güncelle
  useEffect(() => {
    const updatedOffers = offers.map((offer) => {
      const customer = customers.find((c) => c.id === offer.customerId);

      // Her ürün için KDV oranını ayarla
      const itemsWithVat = (offer.items || []).map(item => ({
        ...item,
        vatRate: item.vatRate ?? offer.vatRate ?? 18,
      }));

      // Toplam tutarı hesapla
      const totalAmount = itemsWithVat.reduce(
        (sum, item) => sum + item.quantity * item.price * (1 + item.vatRate / 100),
        0
      );

      return {
        ...offer,
        items: itemsWithVat,
        customerName: customer ? customer.fullName : "Bilinmiyor",
        serviceNames: itemsWithVat.map(i => i.name).join(", "),
        totalAmount,
      };
    });
    setEnhancedOffers(updatedOffers);
  }, [offers, customers]);

  // Teklif ekleme, güncelleme ve silme fonksiyonları
  const addOffer = (formData) => setOffers(prev => [...prev, { id: prev.length + 1, ...formData }]);
  const updateOffer = (updatedOffer) =>
    setOffers(prev => prev.map(o => o.id === updatedOffer.id ? { ...updatedOffer } : o));
  const deleteOffer = (id) => setOffers(prev => prev.filter(o => o.id !== id));

 
  return (
    <OfferContext.Provider value={{ offers: enhancedOffers, addOffer, updateOffer, deleteOffer }}>
      {children}
    </OfferContext.Provider>
  );
};
